import {Component, OnInit} from '@angular/core';
import {TranslateService} from "@ngx-translate/core";
import {Store} from "@ngxs/store";
import {LoadConfigurationFromStorage} from "./configurator/configurator.actions";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  constructor(
    private translate: TranslateService,
    private store: Store
  ) {
    translate.setDefaultLang('nl');
    translate.use('nl');
  }

  ngOnInit() {
    // Load saved configuration from local storage on app initialization
    this.store.dispatch(new LoadConfigurationFromStorage());
  }
}
